module.exports = __webpack_public_path__ + "img/SketchPng0fd2e0e313667b5a9f9256a64260aed746c8d99d64ca93d39cc69e6516e2ec8f.4c801ad2.png";